import * as React from 'react';


type Props = {
  pageSize: number;
  currentPage: number;
  children: React.ReactNode[];
};


/**
 * PaginateScroll: a component that loads results in chunks of a preset size.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const PaginatedScroll: React.FC<Props> = props => {
  const renderedItems = props.children.slice(0, (props.pageSize * props.currentPage));

  return (
    <>
      {renderedItems}
    </>
  );
};

export default PaginatedScroll;